import { render, staticRenderFns } from "./SliderOverview.vue?vue&type=template&id=8b57bc62"
import script from "./SliderOverview.vue?vue&type=script&lang=js"
export * from "./SliderOverview.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports